import { Component, Inject, OnInit } from "@angular/core";
import { Router, NavigationEnd, RouterState, ActivatedRoute} from '@angular/router';
declare var gtag: Function;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from "@angular/platform-browser";
import { DOCUMENT } from "@angular/common";
//import { SharedFormService } from 'src/app/shared-utility/services/shared-form.service';
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "HCP Portal";
  urlIndex = window.location.href.indexOf("login")

  loginFlag: boolean = false;
  hide: boolean = false;
  reset:string;
  //constructor(private fb: FormBuilder, 
   
   // private formDataSvc: SharedFormService){ }
   constructor(
    private router: Router,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document
    ) {
    this.handleRouteEvents();
  }

  handleRouteEvents() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const title = this.getTitle(this.router.routerState, this.router.routerState.root).join('-');
        // this.titleService.setTitle(title);
        gtag('event', 'page_view', {
          page_title: title,
          page_path: event.urlAfterRedirects,
          page_location: this.document.location.href
        })
      }
    });
  }
  
  getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data['title']) {
      data.push(parent.snapshot.data['title']);
    }
    if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }
    return data;
  }


  checkLogin($event) {
    
    if(this.urlIndex > -1) {
      alert("Url container Login");
      this.loginFlag = true;
    }
  }
  ngOnInit(): void {
    // this.formDataSvc.reset.subscribe(res=>{
    //   this.reset = res;
    // })
  }

  // constructor(public router: Router){   
  //   this.router.events.subscribe(event => {
  //      if(event instanceof NavigationEnd){
  //          gtag('config', 'G-2H7M9RBWBK', 
  //                {
  //                  'page_path': event.urlAfterRedirects
  //                }
  //               );
  //       }
  //    }
  // )}
  
}
